import { Routes } from '@angular/router';
import { InterviewPageComponent } from './pages/interview-page/interview-page.component';
import { MedicalHistoryPageComponent } from './pages/medical-history-page/medical-history-page.component';
import { RegistryPageComponent } from './pages/registry-page/registry-page.component';
import { PatientLifeLinePageComponent } from './pages/patient-life-line-page/patient-life-line-page.component';
import { PatientDocumentsPageComponent } from './pages/patient-documents-page/patient-documents-page.component';
import { AiPatientPageComponent } from './pages/ai-patient-page/ai-patient-page.component';
import { AiSummaryAllComponent } from './sections/ai-summary-all/ai-summary-all.component';
import { AiGraphicsComponent } from './sections/ai-graphics/ai-graphics.component';
import { AiAnalysisPageComponent } from './pages/ai-analysis-page/ai-analysis-page.component';
import { InterviewDetailsComponent } from './pages/interview-details/interview-details.component';
import { InvoicesPageComponent } from './pages/invoices-page/invoices-page.component';
import { CreateModifyExpenseStsComponent } from './pages/invoices-page/invoices-sts/create-modify-expense-sts/create-modify-expense-sts.component';
import { ReviewInvoiceStsComponent } from './pages/invoices-page/invoices-sts/review-invoice-sts/review-invoice-sts.component';
import { IssueStsCreditNoteComponent } from './pages/invoices-page/invoices-sts/issue-sts-credit-note/issue-sts-credit-note.component';
import { InvoicesClientsComponent } from './pages/invoices-clients/invoices-clients.component';
import { PatientAiAnalysisComponent } from './pages/patient-ai-analysis/patient-ai-analysis.component';
import { AiPatDmrComponent } from './sections/ai-patdmr/ai-patdmr.component';
import { InterviewNotesComponent } from './sections/interview-notes/interview-notes.component';
import { InterviewAiAppSummComponent } from './sections/interview-ai-topic/interview-ai-sections/interview-ai-appsumm/interview-ai-appsumm.component';
import { InterviewAiNuclearTopicComponent } from './sections/interview-ai-topic/interview-ai-sections/interview-ai-nuclear-topic/interview-ai-nuclear-topic.component';
import { InterviewAiWordcloudComponent } from './sections/interview-ai-topic/interview-ai-sections/interview-ai-wordcloud/interview-ai-wordcloud.component';
import { InterviewAiAiTopicComponent } from './sections/interview-ai-topic/interview-ai-sections/interview-ai-ai-topic/interview-ai-ai-topic.component';
import { SignInPageComponent } from './pages/sign-in-page/sign-in-page.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { CalendarPageComponent } from './pages/calendar-page/calendar-page.component';
import { PersonalAreaPageComponent } from './pages/personal-area-page/personal-area-page.component';
import { DocumentsPageComponent } from './pages/documents-page/documents-page.component';
import { FaqPageComponent } from './pages/faq-page/faq-page.component';
import { authGuard } from './guards/auth.guard';
import { InvoicesBillingDataComponent } from './pages/invoices-billing-data/invoices-billing-data.component';
import { InvoicesSalesComponent } from './pages/invoices-sales/invoices-sales.component';
import { InvoicesReceivedComponent } from './pages/invoices-received/invoices-received.component';
import { PrivacyPolicyPageComponent } from './pages/legal-pages/privacy-policy-page/privacy-policy-page.component';
import { TermsOfServicePageComponent } from './pages/legal-pages/terms-of-service-page/terms-of-service-page.component';
import { SubscriptionRenewalComponent } from './pages/subscription/subscription-renewal/subscription-renewal.component';
import { ValidateSubscriptionPageComponent } from './pages/validate-subscription-page/validate-subscription-page.component';
import { NotFoundPageComponent } from './pages/not-found-page/not-found-page.component';

export const routesNew: Routes = [
  { path: '', component: SignInPageComponent, pathMatch: 'full' },
  {
    path: 'pazienti',
    loadChildren: () =>
      import('./pages/patient-list-page/patient-list-page-routing.module').then(
        (m) => m.PatientListPageRoutingModule
      ),
    canActivate: [authGuard],
  },
  {
    path: 'pazienti/:patientId',
    component: InterviewPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'pazienti/:patientId/medical-history',
    component: MedicalHistoryPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'pazienti/:patientId/registry',
    component: RegistryPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'pazienti/:patientId/life-line',
    component: PatientLifeLinePageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'pazienti/:patientId/documents',
    component: PatientDocumentsPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'pazienti/:patientId/funzioni-ai',
    component: AiPatientPageComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'scheda-clinica-dinamica', pathMatch: 'full' },
      { path: 'scheda-clinica-dinamica', component: AiPatDmrComponent },
      { path: 'sintesi-complessiva', component: AiSummaryAllComponent },
      { path: 'grafico-topic', component: AiGraphicsComponent },
    ],
  },
  {
    path: 'pazienti/:patientId/appointments/:appointmentId',
    component: InterviewDetailsComponent,
    children: [
      { path: '', redirectTo: 'ai/summary', pathMatch: 'full' },
      {
        path: 'ai',
        children: [
          { path: '', redirectTo: 'summary', pathMatch: 'full' },
          { path: 'summary', component: InterviewAiAppSummComponent },
          {
            path: 'nuclear-topic',
            component: InterviewAiNuclearTopicComponent,
          },
          { path: 'wordcloud', component: InterviewAiWordcloudComponent },
          { path: 'aitopic', component: InterviewAiAiTopicComponent },
        ],
      },
      { path: 'notes', component: InterviewNotesComponent },
    ],
    canActivate: [authGuard],
  },
  {
    path: 'analisi-ai',
    component: AiAnalysisPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'analisi-ai/:patientId',
    component: PatientAiAnalysisComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture',
    component: InvoicesPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture/sts',
    component: CreateModifyExpenseStsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture/sts/riepilogo',
    component: ReviewInvoiceStsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture/sts/:invoiceId/riepilogo',
    component: ReviewInvoiceStsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture/sts/:invoiceId',
    component: CreateModifyExpenseStsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture/nota-di-credito-sts',
    component: IssueStsCreditNoteComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture/clienti',
    component: InvoicesClientsComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture/dati-fatturazione',
    component: InvoicesBillingDataComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture/fatturato',
    component: InvoicesSalesComponent,
    canActivate: [authGuard],
  },
  {
    path: 'fatture/ricevute',
    component: InvoicesReceivedComponent,
    canActivate: [authGuard],
  },
  { path: 'homepage', component: HomepageComponent, canActivate: [authGuard] },
  {
    path: 'calendario',
    component: CalendarPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'area-personale',
    component: PersonalAreaPageComponent,
    canActivate: [authGuard],
  },
  {
    path: 'documenti',
    component: DocumentsPageComponent,
    canActivate: [authGuard],
  },
  { path: 'faq', component: FaqPageComponent, canActivate: [authGuard] },
  { path: 'informativa-privacy', component: PrivacyPolicyPageComponent },
  { path: 'termini-di-servizio', component: TermsOfServicePageComponent },
  {
    path: 'subscription/renew',
    component: SubscriptionRenewalComponent,
  },
  {
    path: 'validate-subscription',
    component: ValidateSubscriptionPageComponent,
  },
  { path: '**', component: NotFoundPageComponent }, // Rotta wildcard per reindirizzare tutti i percorsi non mappati
];
